import { render, staticRenderFns } from "./AllItemList.vue?vue&type=template&id=5d654ad4&scoped=true&"
import script from "./AllItemList.vue?vue&type=script&lang=js&"
export * from "./AllItemList.vue?vue&type=script&lang=js&"
import style0 from "./AllItemList.vue?vue&type=style&index=0&id=5d654ad4&prod&lang=scss&scoped=true&"
import style1 from "./AllItemList.vue?vue&type=style&index=1&id=5d654ad4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d654ad4",
  null
  
)

export default component.exports